import {
  ADD_RATERS_TYPE,
  EDIT_RATERS_TYPE,
  LIST_RATERS_TYPE,
  VIEW_RATERS_TYPE,
  DELETE_RATERS_TYPE,
  // text
  ADD_RATERS_TYPE_TEXT,
  EDIT_RATERS_TYPE_TEXT,
  LIST_RATERS_TYPE_TEXT,
  VIEW_RATERS_TYPE_TEXT,
  DELETE_RATERS_TYPE_TEXT,
  RATERS_TYPE_SUCCESS,
  RATERS_TYPE_ERROR,
} from "./actionTypes"

const initialState = {
  successMsg: null,
  error: null,
  editLoading:false
}

const configRatersType = (state = initialState, action) => {
  switch (action.type) {

    // add raters type
    case ADD_RATERS_TYPE:
      state = {
        ...state,
        editLoading: true,
        successMsg: null,
        error: null,
      }
      break
    case RATERS_TYPE_SUCCESS:
      state = {
        ...state,
        loading: false,
        successMsg: action.payload,
        editLoading:false
      }
      break
    case RATERS_TYPE_ERROR:
      state = { ...state, error: action.payload, loading: false,editLoading:false }
      break

    // edit raters type
    case EDIT_RATERS_TYPE:
      state = {
        ...state,
        editLoading: true,
        successMsg: null,
        error: null,
      }
      break

    // list raters type
    case LIST_RATERS_TYPE:
      state = {
        ...state,
        loading: true,
        successMsg: null,
        error: null,
      }
      break

    // view raters type
    case VIEW_RATERS_TYPE:
      state = {
        ...state,
        successMsg: null,
        error: null,
      }
      break

    // delete raters type
    case DELETE_RATERS_TYPE:
      state = {
        ...state,
        loading: true,
        successMsg: null,
        error: null,
      }
      break

    // text
    // add raters type
    case ADD_RATERS_TYPE_TEXT:
      state = {
        ...state,
        editLoading: true,
        successMsg: null,
        error: null,
      }
      break
    case RATERS_TYPE_SUCCESS:
      state = {
        ...state,
        loading: false,
        successMsg: action.payload,
        editLoading:false
      }
      break
    case RATERS_TYPE_ERROR:
      state = { ...state, error: action.payload, loading: false,editLoading:false }
      break

    // edit raters type
    case EDIT_RATERS_TYPE_TEXT:
      state = {
        ...state,
        editLoading: true,
        successMsg: null,
        error: null,
      }
      break

    // list raters type
    case LIST_RATERS_TYPE_TEXT:
      state = {
        ...state,
        loading: true,
        successMsg: null,
        error: null,
      }
      break

    // view raters type
    case VIEW_RATERS_TYPE_TEXT:
      state = {
        ...state,
        successMsg: null,
        error: null,
      }
      break

    // delete raters type
    case DELETE_RATERS_TYPE_TEXT:
      state = {
        ...state,
        loading: true,
        successMsg: null,
        error: null,
      }
      break

    default:
      state = { ...state }
      break
  }
  return state
}

export default configRatersType
